module.exports = __webpack_public_path__ + "img/upDownArrow.ca2e7823.svg";